import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { ContractorHandlerKey } from "../context/ContractorContext";

interface ContractorConfirmDialogProps {
  handlerKey: ContractorHandlerKey | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ContractorConfirmDialog = ({
  handlerKey,
  onConfirm,
  onCancel,
}: ContractorConfirmDialogProps) => {
  const { t } = useTranslation();

  if (!handlerKey) return null;

  return (
    <AlertDialog open={!!handlerKey} onOpenChange={onCancel}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t(`contractors.dialogs.${handlerKey}.title`)}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t(`contractors.dialogs.${handlerKey}.description`)}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onConfirm}>
            {t(`contractors.dialogs.${handlerKey}.confirm`)}
          </AlertDialogAction>
          <AlertDialogCancel>{t("common.cancel")}</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
